import axios from 'axios';
import React, { Component } from 'react';
import history from '../containers/history';
import qs from 'qs';
import { message, Modal, Button, Upload, Input, Form } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import utils from './util'
import servers from '@/api/server.js';

const { TextArea } = Input;
/**
 * 主要params参数
 * @params method {string} 方法名
 * @params url {string} 请求地址  例如：/login 配合baseURL组成完整请求地址
 * @params baseURL {string} 请求地址统一前缀 ***需要提前指定***  例如：http://cangdu.org
 * @params timeout {number} 请求超时时间 默认 30000
 * @params params {object}  get方式传参key值
 * @params headers {string} 指定请求头信息
 * @params withCredentials {boolean} 请求是否携带本地cookies信息默认开启
 * @params validateStatus {func} 默认判断请求成功的范围 200 - 300
 * 其他更多拓展参看axios文档后 自行拓展
 * 注意：params中的数据会覆盖method url 参数，所以如果指定了这2个参数则不需要在params中带入
**/

// axios.defaults.withCredentials = true;
// axios.defaults.timeout = 30000;
// // axios.defaults.method='POST';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

// 创建axios实例
// const service = axios.create({
//   timeout: 30000, // 请求的超时时间
//   headers: {  
//     "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
//   },
//   withCredentials: true // 允许携带cookie
// })
function toFeedback() {
  Modal.confirm({
    title: '反馈内容!',
    okText: '提交',
    cancelText: '取消',
    onOk() {

    },
    content: (
      <div>
        <TextArea placeholder="您可以描述出现问题的操作路径，或者提出您宝贵的建议，谢谢！" size="large" autoComplete="off" disableautocomplete='true' rows={4} />
        {/* <Upload {...props}>
          <span className="btn_inline btn_blue2 f13 mt10"><Icon type="upload" />上传图片</span>
        </Upload> */}
      </div>
    )
  })
}
// // axios拦截器
axios.interceptors.request.use(config => {
  // message.loading('加载中',3)
  if (localStorage.getItem('user')) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
    config.headers.token = `${JSON.parse(localStorage.getItem('user')).token}`;
    // config.headers.JSESSIONID = `${JSON.parse(localStorage.getItem('user')).JSESSIONID}`;
  }
  return config;
});
axios.interceptors.response.use(response => {
  if (response.config.url === servers.annualReportExport || response.config.url === servers.diskFilesDown || response.config.url === servers.annualReportsExport) {
    // utils.downBlobFile(response.data,'组年报导出文件',response.headers['content-disposition'])
    return response.data
  }
  message.destroy()
  // 在这里你可以判断后台返回数据携带的请求码
  if (response.status === 200) {
    // console.log(response.data)
    if (response.data.statusCode === 5000 || response.data.statusCode === 9006) {
      history.replace('/login')
    }
    if (response.data.statusCode === 8888) {
      Modal.confirm({
        title: '服务器请求超时，请稍后再试!',
        icon: <i className='iconfont icon-gantanhao c_lost fl'></i>,
        okText: '确认',
        cancelText: '反馈',
        onCancel() {
          history.push({
            pathname: '/userCenter',
            query: { key: '6' }
          })
        }
      })
      return 
    }
    if (response.data.statusCode === 1000) {
      return response.data
    } else if (response.data.statusCode === 1006) {
      return response.data
    } else if (response.data.statusCode === 9005) {
      return response.data
    } else {
      // message.error(response.data.message)
      // throw Error(response.data.message)
      return response.data
    }
  } else {
    // 非200请求抱错
    return response.data
    throw Error(response.data)
  }
});

export const http = (method, netReqUrl, params = {}, okCallBack, errCallBack, headers) => {
  let _option = {
    method,
    url: netReqUrl,
    params: {
      ...params
    },
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    },
    headers: {
      'Accept': 'application/json',
      // 'content-type': 'application/json',
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      ...headers
    },
    timeout: 40000,
    withCredentials: true, //是否携带cookies发起请求
    validateStatus: (status) => {
      return status >= 200 && status < 300;
    }
  };
  axios.request(_option).then(okCallBack).catch(errCallBack)
}
export const http3 = (method, netReqUrl, data, okCallBack, errCallBack, headers) => {
  let _option = {
    method,
    url: netReqUrl,
    data: data,
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
    headers: {
      'Accept': 'application/json',
      'content-type': 'application/json',
      // 'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      ...headers
    },
    timeout: 40000,
    withCredentials: true, //是否携带cookies发起请求
    validateStatus: (status) => {
      return status >= 200 && status < 300;
    }
  };
  axios.request(_option).then(okCallBack).catch(errCallBack)
}
export const http2 = (method, netReqUrl, params = {}, data = {}, okCallBack, errCallBack, headers, ...rest) => {
  let _option = Object.assign({}, {
    method,
    url: netReqUrl,
    params,
    data: data,
    headers: {
      'Accept': 'application/json',
      // 'content-type': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      ...headers
    },
    timeout: 10000000,
    withCredentials: true, //是否携带cookies发起请求
    validateStatus: (status) => {
      return status >= 200 && status < 300;
    },
  }, ...rest);
  console.log(_option)
  axios.request(_option).then(okCallBack).catch(errCallBack)
}


// export default http;
